import type {
  INotificationSetting,
  INotificationSettingTemplate,
  INotificationTemplate,
  INotificationTemplateLocale,
} from '@/types/Data'
import type {
  ICreateNotificationTemplate,
  IGetNotificationTemplateLocaleList,
  ISendNotification,
  ISetNotificationSettingActive,
  IUpdateNotificationTemplate,
  IUpdateNotificationTemplateLocale,
} from '@/types/Request'
import BaseService from '../BaseService'

export default class NotificationServices extends BaseService {
  GetNotificationSettingList(ParentId: string | null = null) {
    return this.GET<INotificationSetting[]>(this.PATHS.GET_NOTIFICATION_SETTING_LIST, { ParentId })
  }

  GetNotificationSettingTemplateList(NotificationSettingId: string) {
    return this.GET<INotificationSettingTemplate[]>(
      this.PATHS.GET_NOTIFICATION_SETTING_TEMPLATE_LIST,
      { NotificationSettingId },
    )
  }

  SetNotificationSettingActive(payload: ISetNotificationSettingActive) {
    return this.POST<void>(this.PATHS.SET_NOTIFICATION_SETTING_ACTIVE, payload)
  }

  GetNotificationTemplateList(ParentId: string | null = null) {
    return this.GET<INotificationTemplate[]>(this.PATHS.GET_NOTIFICATION_TEMPLATE_LIST, {
      ParentId,
    })
  }

  CreateNotificationTemplate(payload: ICreateNotificationTemplate) {
    return this.POST<string>(this.PATHS.CREATE_NOTIFICATION_TEMPLATE, payload)
  }

  UpdateNotificationTemplate(payload: IUpdateNotificationTemplate) {
    return this.POST<void>(this.PATHS.UPDATE_NOTIFICATION_TEMPLATE, payload)
  }

  GetNotificationTemplateLocaleList(payload: IGetNotificationTemplateLocaleList) {
    return this.GET<INotificationTemplateLocale[]>(this.PATHS.GET_NOTIFICATION_TEMPLATE_LOCALE, {
      ...payload,
    })
  }

  UpdateNotificationTemplateLocale(payload: IUpdateNotificationTemplateLocale) {
    return this.POST<void>(this.PATHS.UPDATE_NOTIFICATION_TEMPLATE_LOCALE, payload)
  }

  SendNotification(payload: ISendNotification) {
    return this.POST<void>(this.PATHS.SEND_NOTIFICATION, payload)
  }
}
